import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { isContentCart } from './is-content-cart';
import { SiteFeature } from '@gn-audio/core/api/site-settings/enums';
import { isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';

/**
 * Checks whether DR regular cart can be bootstrapped
 * @async
 */
export const canBootstrapCart = async (): Promise<boolean> => {
  // Checks whether ecom is enabled.
  if (!await canBootstrapByEcomState()) {
    return false;
  }

  // Checks site features' state (SiteFeature.SfccBasket).
  if (await isSiteFeatureEnabled(SiteFeature.SfccBasket)) {
    return false;
  }

  return canBootstrapCartByType();
};

/**
 * Checks whether DR regular cart can be boostrapped based on ecom state
 * @async
 */
export const canBootstrapByEcomState = async (): Promise<boolean> => {
  return !!(await fetchEcomSetting())?.ecomEnabled;
};

/**
 * Checks whether DR regular cart can be bootstrapped based on type
 */
export const canBootstrapCartByType = (): boolean => {
  return !isContentCart();
};
